import { createSlice } from "@reduxjs/toolkit";
import { addCaseCredit } from "@custom/rtk-apis/Setting/creditForCaseToCase/addCaseCredit";

const initialState = {
  status: "",
  result: {},
  msg: "",
  loading: false,
  error: ""
};

const addCaseCreditSlice = createSlice({
  name: "addCaseCreditSlice",
  initialState,
  reducers: {
    clearAddCaseCreditState: (state) => {
      state.status = '';
      state.result = {};
      state.msg = '';
      state.loading = false;
      state.error = '';
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(addCaseCredit.pending, (state) => {
        state.loading = true;
      })
      .addCase(addCaseCredit.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.status = "SUCCESS";
        state.result = payload.result;
        state.msg = payload.msg;
      })
      .addCase(addCaseCredit.rejected, (state, { payload }) => {
        console.log("payload", payload);
        state.loading = false;
        state.error = payload as string;
        state.status = "FAILED";
      });
  }
});

export default addCaseCreditSlice.reducer;
export const { clearAddCaseCreditState } = addCaseCreditSlice.actions;
